import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Transaction from '../../entities/transaction';
import Invoice from '../../entities/invoice';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteTransaction(): boolean {
return true;
}
export function collectTransactionDeleteImpact(transaction: Transaction, context: DeleteImpactContext): void {
const key = 'transaction:' + transaction.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const invoiceTransactionIdsImpact = workingRows<Invoice>('invoice', findAll<Invoice>('invoices')).filter(invoiceRef => invoiceRef.transactionIds?.includes(transaction.id) && !(invoiceRef.invoiceStatus === 'F'));
invoiceTransactionIdsImpact.forEach(invoiceRef => addDeleteImpact(context, 'invoice:' + invoiceRef.id, 'invoices'));}
export function deleteImpactTransaction(transaction: Transaction): DeleteImpact {
const context = deleteImpactContext();
collectTransactionDeleteImpact(transaction, context);
return deleteImpactCounts(context);
}
export function deleteTransaction(transaction: Transaction, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteTransaction()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectTransactionDeleteImpact(transaction, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || transaction.id};
}
const key = 'transaction:' + transaction.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Invoice>('invoice', [...store.getState().invoices.getMappingFor('transactionIds', transaction.id)]).filter(invoiceTemp => invoiceTemp.transactionIds?.includes(transaction.id)).forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
if (_invoice.status === 'D') return;
if (_invoice.invoiceStatus === 'F') return;
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.transactionIds = _invoice.transactionIds?.filter(id => id !== transaction.id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice), 'invoice:' + _invoice.id);
});
const deleted = transaction.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.TransactionActions.removeTransactionQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceTransaction(transaction: Transaction, replaceWith: Transaction, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = transaction.id;}
const _work = workingSet();
workingRows<Invoice>('invoice', [...store.getState().invoices.getMappingFor('transactionIds', transaction.id)]).filter(invoiceTemp => invoiceTemp.transactionIds?.includes(transaction.id)).forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
if (_invoice.status === 'D') return;
if (_invoice.invoiceStatus === 'F') return;
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.transactionIds = _invoice.transactionIds?.map(id => (id === transaction.id) ? replaceWith.id : id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});



return transaction;
}
